import { useState, useEffect } from 'react'
import ModuleTopic from './moduleTopic';
import SignUpPopUp from '../../Common/SignUpPopUp';
import { AnimatePresence } from 'framer-motion';

import downArrow from "../../../img/downArrow.svg";


const ModuleTopicsCard = ({ topics }) => {
    const [showPopUp, setShowPopUp] = useState(false);
    const [showLockUpError,setShowLockUpError] = useState(false);
    
    useEffect(() => {
      if (showPopUp) {
        const timer = setTimeout(() => {
          setShowPopUp(false);
        }, 4000);
        return () => clearTimeout(timer);
      }
      if (showLockUpError) {
        const timer = setTimeout(() => {
          setShowLockUpError(false);
        }, 4000);
        return () => clearTimeout(timer);
      }
    }, [showPopUp, showLockUpError]);
  return (
    <div className='space-y-3'>
        <div className=''>
            {
                topics.map((topic, index) => (
                    <ModuleTopic 
                      key={index}
                      question={topic.question}
                      preview={topic.preview}
                      src={topic.src}
                      setShowLockUpError={setShowLockUpError}
                    />
                ))
            }
        </div>
        <div className='flex items-center justify-center'>
            <div className='flex items-center gap-3 w-fit sm:text-[16px] sm:leading-6 sm:py-2 sm:px-5 rounded-[20px] text-[#3940A0] sm:border-[#3940A0] sm:border-[1px] cursor-pointer font-gilroy-semibold' onClick={() => setShowPopUp(true)}>
                <span>Show more</span>
                <img src={downArrow} alt='Icon' height={10} width={10}/>
            </div>
        </div>
        <AnimatePresence>
        {
          showPopUp && 
          <SignUpPopUp title='Sign up to get access to more!' mobileViewTitle='Sign up to get access!'/>
        }
        {
          showLockUpError && 
          <SignUpPopUp title='Sign up to unlock!' mobileViewTitle='Sign up to unlock!'/>
        }
        </AnimatePresence>
    </div>
  )
}

export default ModuleTopicsCard;
